var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unity-upload"},[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":"","limit":10,"show-file-list":false,"before-upload":_vm.initUploadData,"http-request":_vm.uploadRequest,"accept":".unity3d"}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v(_vm._s(_vm.btnName))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }